import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  VEHICLES_REFRESH: createSagaAction('VEHICLES_REFRESH'),
  CREATE_VEHICLE: createSagaAction('CREATE_VEHICLE'),
  EDIT_VEHICLE: createSagaAction('EDIT_VEHICLE'),
  DELETE_VEHICLE: createSagaAction('DELETE_VEHICLE'),
  EDIT_VEHICLE_STATUS: createSagaAction('EDIT_VEHICLE_STATUS'),
  UPLOAD_VEHICLE_ATTACHMENT: createSagaAction('UPLOAD_VEHICLE_ATTACHMENT'),
  GET_VEHICLE_ATTACHMENTS: createSagaAction('GET_VEHICLE_ATTACHMENTS'),
  UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION'),
  DELETE_VEHICLE_ATTACHMENT: createSagaAction('DELETE_VEHICLE_ATTACHMENT'),
  // notes
  GET_VEHICLE_NOTE: createSagaAction('GET_VEHICLE_NOTE'),
  CREATE_VEHICLE_NOTE: createSagaAction('CREATE_VEHICLE_NOTE'),
  EDIT_VEHICLE_NOTE: createSagaAction('EDIT_VEHICLE_NOTE'),
  DELETE_VEHICLE_NOTE: createSagaAction('DELETE_VEHICLE_NOTE'),
  // follow ups
  GET_VEHICLE_FOLLOW_UP: createSagaAction('GET_VEHICLE_FOLLOW_UP'),
  CREATE_VEHICLE_FOLLOW_UP: createSagaAction('CREATE_VEHICLE_FOLLOW_UP'),
  EDIT_VEHICLE_FOLLOW_UP: createSagaAction('EDIT_VEHICLE_FOLLOW_UP'),
  DELETE_VEHICLE_FOLLOW_UP: createSagaAction('DELETE_VEHICLE_FOLLOW_UP'),
  // Scheduled Deliveries
  FETCH_SCHEDULED_DELIVERIES: createSagaAction('FETCH_SCHEDULED_DELIVERIES')
}

// Action Creators
export const actions = {
  vehiclesRefresh: () => ({ type: constants.VEHICLES_REFRESH.ACTION }),
  createVehicle: ({ content, userId }) => ({
    type: constants.CREATE_VEHICLE.ACTION,
    content,
    userId
  }),
  fetchScheduledDeliveries: ({ vehicleId }) => ({
    type: constants.FETCH_SCHEDULED_DELIVERIES.ACTION,
    vehicleId
  }),
  editVehicle: ({ content, vehicleId }) => ({
    type: constants.EDIT_VEHICLE.ACTION,
    content,
    vehicleId
  }),
  deleteVehicle: ({ vehicleId }) => ({
    type: constants.DELETE_VEHICLE.ACTION,
    vehicleId
  }),
  setStatusVehicle: ({ content, vehicleId }) => ({
    type: constants.EDIT_VEHICLE_STATUS.ACTION,
    content,
    vehicleId
  }),
  // VehicleAttachment actions
  uploadVehicleAttachment: ({ formData, vehicleId }) => ({
    type: constants.UPLOAD_VEHICLE_ATTACHMENT.ACTION,
    formData,
    vehicleId
  }),

  getVehicleAttachments: ({ vehicleId }) => ({
    type: constants.GET_VEHICLE_ATTACHMENTS.ACTION,
    vehicleId
  }),

  updateVehicleAttachmentDescription: ({ attachmentId, vehicleId, description, userId }) => ({
    type: constants.UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    vehicleId,
    description,
    userId
  }),

  deleteVehicleAttachment: ({ attachmentId, vehicleId }) => ({
    type: constants.DELETE_VEHICLE_ATTACHMENT.ACTION,
    attachmentId,
    vehicleId
  }),
  // notes
  getVehicleNote: ({ vehicleId }) => ({
    type: constants.GET_VEHICLE_NOTE.ACTION,
    vehicleId
  }),
  createVehicleNote: ({ content, userId, vehicleId }) => ({
    type: constants.CREATE_VEHICLE_NOTE.ACTION,
    content,
    userId,
    vehicleId
  }),
  editVehicleNote: ({ content, noteId, vehicleId }) => ({
    type: constants.EDIT_VEHICLE_NOTE.ACTION,
    content,
    noteId,
    vehicleId
  }),
  deleteVehicleNote: ({ noteId, vehicleId }) => ({
    type: constants.DELETE_VEHICLE_NOTE.ACTION,
    noteId,
    vehicleId
  }),
  // followUps
  getVehicleFollowUp: ({ vehicleId }) => ({
    type: constants.GET_VEHICLE_FOLLOW_UP.ACTION,
    vehicleId
  }),
  createVehicleFollowUp: ({ content, userId, vehicleId }) => ({
    type: constants.CREATE_VEHICLE_FOLLOW_UP.ACTION,
    content,
    userId,
    vehicleId
  }),
  editVehicleFollowUp: ({ content, followUpId, vehicleId }) => ({
    type: constants.EDIT_VEHICLE_FOLLOW_UP.ACTION,
    content,
    followUpId,
    vehicleId
  }),
  deleteVehicleFollowUp: ({ followUpId, vehicleId }) => ({
    type: constants.DELETE_VEHICLE_FOLLOW_UP.ACTION,
    followUpId,
    vehicleId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.VEHICLES_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CREATE_VEHICLE.ACTION:
      return { ...state, loading: true }
    case constants.CREATE_VEHICLE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle created!'
      }
    case constants.CREATE_VEHICLE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating vehicle, please try again.'
      }
    case constants.EDIT_VEHICLE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle edited!'
      }
    case constants.EDIT_VEHICLE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems editing vehicle, please try again.'
      }
    case constants.DELETE_VEHICLE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle deleted!'
      }
    case constants.DELETE_VEHICLE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems deleting vehicle, please try again.'
      }
    case constants.EDIT_VEHICLE_STATUS.ACTION:
      return { ...state, loading: true }
    case constants.EDIT_VEHICLE_STATUS.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle created!'
      }
    case constants.EDIT_VEHICLE_STATUS.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating vehicle, please try again.'
      }
    case constants.UPLOAD_VEHICLE_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingVehicleAttachment: true }
    case constants.UPLOAD_VEHICLE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingVehicleAttachment: false
      }
    case constants.FETCH_SCHEDULED_DELIVERIES.ACTION:
      return { ...state, loadingScheduledDeliveries: true }
    case constants.FETCH_SCHEDULED_DELIVERIES.SUCCESS:
      return {
        ...state,
        error: null,
        loadingScheduledDeliveries: false,
        scheduledDeliveries: payload
      }
    case constants.GET_VEHICLE_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingVehicleAttachments: true }
    case constants.GET_VEHICLE_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        vehicleVehicleAttachments: payload,
        loadingVehicleAttachments: false
      }

    case constants.UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_VEHICLE_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingVehicleAttachment: true }
    case constants.DELETE_VEHICLE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingVehicleAttachment: false
      }

    // NOTES
    case constants.GET_VEHICLE_NOTE.SUCCESS:
      return { ...state, vehiclesNotes: payload }

    case constants.CREATE_VEHICLE_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_VEHICLE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_VEHICLE_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_VEHICLE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_VEHICLE_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_VEHICLE_NOTE.SUCCESS:
      return {
        ...state
      }
    // FOLLOW UPS
    case constants.GET_VEHICLE_FOLLOW_UP.SUCCESS:
      return { ...state, vehiclesFollowUps: payload }

    case constants.CREATE_VEHICLE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.CREATE_VEHICLE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_VEHICLE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.EDIT_VEHICLE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_VEHICLE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.DELETE_VEHICLE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/vehiclesActions.js